export const parseVastFromUrlAndSelectBestVideo = async (vastUrl: string): Promise<{
  width: number;
  height: number;
  videoUrl: string;
} | null> => {
  const url = new URL(vastUrl);
  // Remove non-essential keys to avoid possible issues accessing VAST
  const keepKeys = new Set([
    '_media',
    'ctx',
    'cmp',
    'sid',
    'plc',
    '_vast'
  ]);

  [...url.searchParams.keys()].forEach(key => {
    if (!keepKeys.has(key)) {
      url.searchParams.delete(key);
    }
  });

  const res = await fetch(url);

  if (!res.ok) return null;

  const vastXml = await res.text();
  const parser = new DOMParser();
  const xml = parser.parseFromString(vastXml, 'application/xml');

  const mediaFiles = Array.from(xml.getElementsByTagName('MediaFile'));

  const videos = mediaFiles.map((mf) => ({
    url: mf.textContent?.trim() || '',
    width: parseInt(mf.getAttribute('width') || '0'),
    height: parseInt(mf.getAttribute('height') || '0'),
    type: mf.getAttribute('type') || '',
  }));

  const mp4s = videos.filter(v => v.type === 'video/mp4' && v.url);

  if (mp4s.length === 0) return null;

  const bestVideo = mp4s.reduce((a, b) => (a.width * a.height > b.width * b.height ? a : b));

  return {
    width: bestVideo.width,
    height: bestVideo.height,
    videoUrl: bestVideo.url,
  };
}
